
import { inject, Injectable } from "@angular/core";
import { ApiService } from "./apiService";
import { IException } from "@tylertech/tyler-api-types";

/**
 * ExceptionService is a generated service implementation. Any edits will be overridden!
 */
@Injectable()
export class ExceptionService {
    private readonly $apiService = inject(ApiService);
    
    LogException(exception: IException): Promise<void> {
        return this.$apiService.sendAuth("IExceptionService/LogException", exception);
    }
}
